import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { AppService } from '../../app.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { SelectOption } from '../../interfaces/select-option.interface';
import { BillingClient } from './interfaces/billing-client.interface';
import { MonthlyBillingConfigService } from '../../services/monthly-billing-config/monthly-billing-config.service';
import { BillingTermDetail } from './interfaces/billing-term-detail.interface';

const DELETE_CLIENT = 'Are you sure you want to archive this client?';
const DELETE_DETAIL =
    'Are you sure you want to delete this billing term detail?';

enum TYPE_TO_DELETE {
    CLIENT = 'client',
    DETAIL = 'detail',
}

@Component({
    selector: 'app-monthly-billing-config',
    templateUrl: './monthly-billing-config.component.html',
    styleUrl: './monthly-billing-config.component.css',
})
export class MonthlyBillingConfigComponent {
    public constructor(
        public appService: AppService,
        private cdr: ChangeDetectorRef,
        private apiService: MonthlyBillingConfigService,
        private etlIngestionService: EtlIngestionService,
    ) {}

    TYPE_TO_DELETE = TYPE_TO_DELETE;

    creditors: any;
    selectedCreditor?: any;

    isShowDetails: any[] = [];

    clients: BillingClient[] | undefined;
    pageClient: number = 1;
    rowsClient: number = 10;
    totalRecordsClient: number = 0;

    isShowClientForm: boolean = false;
    isShowBillingTermForm: boolean = false;
    isDeleteModalVisible: boolean = false;

    deleteMessage: string = DELETE_CLIENT;

    isSaveClickedClient: boolean = false;
    toEditClientId: number | undefined;

    toEditBillingDetail: BillingTermDetail | undefined;

    toDeleteId: number | undefined;
    rowTypeToDelete: string = TYPE_TO_DELETE.CLIENT;

    companyName: string | undefined;
    country: string | undefined;
    streetAddress: string | undefined;
    recipientToFullName: string | undefined;
    city: string | undefined;
    termsDays: number | undefined;
    stateAbbr?: string;
    monthlyMinimum: number | undefined;
    postalCode: string | undefined;
    callbackRange: number | undefined;

    isSaveClickedBillingTermDetail: boolean = false;
    termTypeId: number | undefined;
    feePercentage: number | undefined;
    min: number | undefined;
    max: number | undefined;

    termTypeOptions: SelectOption[] | undefined;

    stateAbbrOptions: string[] | undefined;

    cityOptions: any;
    stateOptions: SelectOption[] = [
        {
            Value: 'AL',
            Label: 'Alabama',
        },
        {
            Value: 'AK',
            Label: 'Alaska',
        },
        {
            Value: 'AZ',
            Label: 'Arizona',
        },
        {
            Value: 'AR',
            Label: 'Arkansas',
        },
        {
            Value: 'CA',
            Label: 'California',
        },
        {
            Value: 'CO',
            Label: 'Colorado',
        },
        {
            Value: 'CT',
            Label: 'Connecticut',
        },
        {
            Value: 'DE',
            Label: 'Delaware',
        },
        {
            Value: 'FL',
            Label: 'Florida',
        },
        {
            Value: 'GA',
            Label: 'Georgia',
        },
        {
            Value: 'HI',
            Label: 'Hawaii',
        },
        {
            Value: 'ID',
            Label: 'Idaho',
        },
        {
            Value: 'IL',
            Label: 'Illinois',
        },
        {
            Value: 'IN',
            Label: 'Indiana',
        },
        {
            Value: 'IA',
            Label: 'Iowa',
        },
        {
            Value: 'KS',
            Label: 'Kansas',
        },
        {
            Value: 'KY',
            Label: 'Kentucky',
        },
        {
            Value: 'LA',
            Label: 'Louisiana',
        },
        {
            Value: 'ME',
            Label: 'Maine',
        },
        {
            Value: 'MD',
            Label: 'Maryland',
        },
        {
            Value: 'MA',
            Label: 'Massachusetts',
        },
        {
            Value: 'MI',
            Label: 'Michigan',
        },
        {
            Value: 'MN',
            Label: 'Minnesota',
        },
        {
            Value: 'MS',
            Label: 'Mississippi',
        },
        {
            Value: 'MO',
            Label: 'Missouri',
        },
        {
            Value: 'MT',
            Label: 'Montana',
        },
        {
            Value: 'NE',
            Label: 'Nebraska',
        },
        {
            Value: 'NV',
            Label: 'Nevada',
        },
        {
            Value: 'NH',
            Label: 'New Hampshire',
        },
        {
            Value: 'NJ',
            Label: 'New Jersey',
        },
        {
            Value: 'NM',
            Label: 'New Mexico',
        },
        {
            Value: 'NY',
            Label: 'New York',
        },
        {
            Value: 'NC',
            Label: 'North Carolina',
        },
        {
            Value: 'ND',
            Label: 'North Dakota',
        },
        {
            Value: 'OH',
            Label: 'Ohio',
        },
        {
            Value: 'OK',
            Label: 'Oklahoma',
        },
        {
            Value: 'OR',
            Label: 'Oregon',
        },
        {
            Value: 'PA',
            Label: 'Pennsylvania',
        },
        {
            Value: 'RI',
            Label: 'Rhode Island',
        },
        {
            Value: 'SC',
            Label: 'South Carolina',
        },
        {
            Value: 'SD',
            Label: 'South Dakota',
        },
        {
            Value: 'TN',
            Label: 'Tennessee',
        },
        {
            Value: 'TX',
            Label: 'Texas',
        },
        {
            Value: 'UT',
            Label: 'Utah',
        },
        {
            Value: 'VT',
            Label: 'Vermont',
        },
        {
            Value: 'VA',
            Label: 'Virginia',
        },
        {
            Value: 'WA',
            Label: 'Washington',
        },
        {
            Value: 'WV',
            Label: 'West Virginia',
        },
        {
            Value: 'WI',
            Label: 'Wisconsin',
        },
        {
            Value: 'WY',
            Label: 'Wyoming',
        },
        { Value: 'DC', Label: 'District of Columbia' },
        { Value: 'AS', Label: 'American Samoa' },
        { Value: 'GU', Label: 'Guam' },
        { Value: 'MP', Label: 'Northern Mariana Islands' },
        { Value: 'PR', Label: 'Puerto Rico' },
        { Value: 'UM', Label: 'United States Minor Outlying Islands' },
        { Value: 'VI', Label: 'Virgin Islands' },
    ];

    isArrayWithData = isArrayWithData;

    ngOnInit() {
        this.getListOfCreditors();
        this.httpGetAllBillingClients();

        this.httpGetAllTermTypes();
    }

    get hasTableData(): boolean {
        return isArrayWithData(this.clients);
    }

    // getMockData = () => {
    //     this.clients = [
    //         {
    //             CreatedBy: 'system',
    //             ClientId: 1,
    //             CompanyName: 'Payoff Inc.',
    //             StreetAddress: '3200 Park Center Drive #800',
    //             City: 'Costa Mesa',
    //             StateAbbr: 'CA',
    //             PostalCode: 92626,
    //             Country: 'USA',
    //             RecientToFullName: 'Praful Dabir',
    //             TermsDays: 30,
    //             MonthlyMinimum: 5000,
    //             CallbackRange: 20,
    //             BillingTermDetails: [
    //                 {
    //                     ClientBillingTermDetailId: 2,
    //                     ClientId: 2,
    //                     CreditorId: 9,
    //                     TermType: 'Settlement',
    //                     TermTypeId: 1,
    //                     FeePercentage: 19500,
    //                     Min: undefined,
    //                     Max: 10,
    //                     CreatedOnUtc: new Date(),
    //                     CreatedBy: 'system',
    //                 },
    //                 {
    //                     ClientBillingTermDetailId: 2,
    //                     ClientId: 2,
    //                     CreditorId: 9,
    //                     TermType: 'Settlement',
    //                     TermTypeId: 2,
    //                     FeePercentage: 19500,
    //                     Min: undefined,
    //                     Max: 10,
    //                     CreatedOnUtc: new Date(),
    //                     CreatedBy: 'system',
    //                 },
    //             ],
    //         },
    //         {
    //             CreatedBy: 'system',
    //             ClientId: 2,
    //             CompanyName: 'MoneyKey',
    //             StreetAddress: '3422 Old Capitol Trail, Suite 1613',
    //             City: 'Wilmington',
    //             StateAbbr: 'DE',
    //             PostalCode: 19808,
    //             Country: 'USA',
    //             RecientToFullName: 'Sean Huxtable',
    //             TermsDays: 14,
    //             MonthlyMinimum: undefined,
    //             CallbackRange: 20,
    //         },
    //     ];

    //     this.termTypeOptions = [
    //         { Label: 'DebtAge', Value: 1 },
    //         { Label: 'Settlement', Value: 2 },
    //         { Label: 'Active Account', Value: 3 },
    //     ];

    //     this.stateAbbrOptions = ['CA', 'NY', 'PR', 'VI', 'MA'];

    //     this.stateAbbrOptions = [
    //         'Richmond',
    //         'Sandisfield',
    //         'Savoy',
    //         'Sheffield',
    //         'South Egremont',
    //         'Costa Mesa',
    //         'Wilmington',
    //     ];
    // };

    getListOfCreditors = () => {
        this.etlIngestionService.getCreditors().subscribe((res: any) => {
            if (
                !!res &&
                res.Creditors &&
                Array.isArray(res.Creditors) &&
                res.Creditors.length > 0
            ) {
                this.creditors = res.Creditors;
            }
        });
    };

    toggleDetails = (clientId: number) => {
        if (this.isShowDetails.includes(clientId)) {
            this.isShowDetails = this.isShowDetails.filter(
                (i) => i !== clientId,
            );
        } else {
            this.isShowDetails = [...this.isShowDetails, clientId];

            if (
                !isArrayWithData(
                    this.clients?.find(
                        (i: BillingClient) => i.ClientId === clientId,
                    )?.BillingTermDetails,
                )
            ) {
                this.httpGetBillingTermDetailsByClientId(clientId);
            }
        }
    };

    onSelectCreditor(event: any) {
        this.selectedCreditor = event;
    }

    onPageChangeClient(event: any) {
        this.pageClient = event.page + 1;
        this.rowsClient = event.rows;
        this.isShowDetails = [];
        this.httpGetAllBillingClients();
    }

    clearClientForm = () => {
        this.selectedCreditor = undefined;
        this.isSaveClickedClient = false;
        this.companyName = undefined;
        this.streetAddress = undefined;
        this.city = undefined;
        this.stateAbbr = undefined;
        this.country = undefined;
        this.termsDays = undefined;
        this.monthlyMinimum = undefined;
        this.callbackRange = undefined;
        this.postalCode = undefined;
        this.recipientToFullName = undefined;
    };

    clearBillingDetailForm = () => {
        this.selectedCreditor = undefined;
        this.isSaveClickedBillingTermDetail = false;
        this.termTypeId = undefined;
        this.feePercentage = undefined;
        this.min = undefined;
        this.max = undefined;
    };

    onOpenBillingDetailForm(
        clientId: number,
        detail: BillingTermDetail | undefined = undefined,
    ) {
        this.isShowBillingTermForm = true;
        this.toEditClientId = clientId;
        if (detail) {
            this.termTypeId = detail.TermTypeId;
            this.feePercentage = detail.FeePercentage;
            this.min = detail.Min;
            this.max = detail.Max;
            const selectedCreditor = this.creditors.find(
                (i: any) => i.CreditorId === detail.CreditorId.toString(),
            );
            this.selectedCreditor = selectedCreditor;
            this.toEditBillingDetail = detail;
        } else {
            this.clearBillingDetailForm();
        }
    }

    onOpenClientForm(client: any | undefined = undefined) {
        this.toEditClientId = client?.ClientId;
        this.isShowClientForm = true;
        if (client) {
            this.companyName = client.CompanyName;
            this.streetAddress = client.StreetAddress;
            this.city = client.City;
            this.stateAbbr = client.StateAbbr;
            this.country = client.Country;
            this.termsDays = client.TermsDays;
            this.monthlyMinimum = client.MonthlyMinimum;
            this.callbackRange = client.CallbackRange;
            this.postalCode = client.PostalCode;
            this.recipientToFullName = client.RecientToFullName;
        } else {
            this.clearClientForm();
        }
    }

    onOpenDeleteModal(id: number, type: string, clientId?: number) {
        this.toDeleteId = id;
        this.isDeleteModalVisible = true;
        this.toEditClientId = clientId;
        this.deleteMessage =
            type === TYPE_TO_DELETE.CLIENT ? DELETE_CLIENT : DELETE_DETAIL;
        this.rowTypeToDelete = type;
    }

    onConfirmDelete() {
        if (!!this.toDeleteId) {
            this.appService.isShowPageSpinner = true;
            if (this.rowTypeToDelete === TYPE_TO_DELETE.CLIENT) {
                this.httpDeleteClient();
            } else {
                this.httpDeleteBillingTermDetail();
            }
        }
    }

    validateInputsClient = (): boolean => {
        return (
            !!this.recipientToFullName &&
            !!this.termsDays &&
            !!this.callbackRange
        );
    };

    validateInputsTermDetail = (): boolean => {
        return !!this.termTypeId && !!this.feePercentage;
    };

    prepareSavePayloadBillingClient = (
        id: number | undefined = undefined,
    ): BillingClient => {
        return {
            CompanyName: this.companyName,
            Country: this.country,
            MonthlyMinimum: this.monthlyMinimum,
            PostalCode: this.postalCode?.toString(),
            TermsDays: this.termsDays,
            ClientId: id || 0,
            City: this.city,
            CallbackRange: this.callbackRange,
            StateAbbr: this.stateAbbr,
            RecientToFullName: this.recipientToFullName,
            StreetAddress: this.streetAddress,
        } as BillingClient;
    };

    prepareSavePayloadBillingTermDetail = (
        billingTermDetailId: number = 0,
    ): BillingTermDetail => {
        return {
            ClientBillingTermDetailId: billingTermDetailId,
            ClientId: this.toEditClientId,
            CreditorId: parseInt(this.selectedCreditor.CreditorId!),
            Min: this.min,
            Max: this.max,
            TermTypeId: this.termTypeId,
            FeePercentage: this.feePercentage,
        } as BillingTermDetail;
    };

    onSaveBillingClient() {
        this.isSaveClickedClient = true;
        if (this.validateInputsClient()) {
            this.appService.isShowPageSpinner = true;
            if (!this.toEditClientId) {
                const payload = this.prepareSavePayloadBillingClient();
                this.apiService
                    .httpPostBillingClient(payload)
                    .pipe(
                        tap((res: any) => {
                            if (res?.id) {
                                this.appService.showCommonMessageDialog(
                                    'Success',
                                    'New billing client has been successfully created.',
                                );

                                this.isShowClientForm = false;

                                const newRow = {
                                    ...payload,
                                    ClientId: res.id,
                                };

                                let newClients = isArrayWithData(this.clients)
                                    ? this.clients
                                    : [];
                                newClients?.unshift(newRow);
                                this.clients = newClients;

                                this.cdr.detectChanges();
                            } else {
                                throw new Error(
                                    'No new Id generated. Please refresh the page.',
                                );
                            }
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {
                            this.appService.isShowPageSpinner = false;
                        }),
                    )
                    .subscribe();
            } else {
                const payload = this.prepareSavePayloadBillingClient(
                    this.toEditClientId,
                );
                this.apiService
                    .httpPutBillingClient(payload)
                    .pipe(
                        tap((res: any) => {
                            this.isShowClientForm = false;

                            this.appService.showCommonMessageDialog(
                                'Success',
                                'Billing client has been successfully updated.',
                            );

                            this.clients = this.clients?.map(
                                (item: BillingClient) => {
                                    let updatedItem = { ...item };
                                    if (item.ClientId === this.toEditClientId) {
                                        updatedItem = {
                                            ...payload,
                                        };
                                    }
                                    return updatedItem;
                                },
                            );
                            this.cdr.detectChanges();
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {
                            this.appService.isShowPageSpinner = false;
                        }),
                    )
                    .subscribe();
            }
        } else {
            this.appService.showCommonMessageDialog(
                'Validation',
                'Please resolve all validation errors first.',
            );
        }
    }

    onSaveBillingTermDetail() {
        const resetBillingTermDetailTable = () => {
            this.isShowClientForm = false;
            this.httpGetBillingTermDetailsByClientId(this.toEditClientId!);
        };

        this.isSaveClickedBillingTermDetail = true;
        if (this.validateInputsTermDetail()) {
            this.appService.isShowPageSpinner = true;

            if (!this.toEditBillingDetail) {
                const payload = this.prepareSavePayloadBillingTermDetail();

                this.apiService
                    .httpPostBillingTermDetail(payload)
                    .pipe(
                        tap((res: any) => {
                            if (res?.id) {
                                this.isShowBillingTermForm = false;

                                this.appService.showCommonMessageDialog(
                                    'Success',
                                    'New client billing term detail has been successfully created.',
                                );

                                this.clients = this.clients?.map(
                                    (client: BillingClient) => {
                                        let updatedClient = { ...client };
                                        if (
                                            updatedClient.ClientId ===
                                            this.toEditClientId
                                        ) {
                                            let newBillingTermDetails =
                                                isArrayWithData(
                                                    updatedClient.BillingTermDetails,
                                                )
                                                    ? updatedClient.BillingTermDetails
                                                    : [];

                                            newBillingTermDetails?.unshift({
                                                ...payload,
                                                ClientBillingTermDetailId:
                                                    res.id,
                                                TermType:
                                                    this.termTypeOptions?.find(
                                                        (i: SelectOption) =>
                                                            i.Value ===
                                                            payload.TermTypeId,
                                                    )?.Label,
                                                Creditor: this.creditors.find(
                                                    (i: any) =>
                                                        i.CreditorId ==
                                                        payload.CreditorId,
                                                )?.CompanyName,
                                            });
                                            updatedClient.BillingTermDetails =
                                                newBillingTermDetails;
                                        }
                                        return updatedClient;
                                    },
                                );
                            } else {
                                throw new Error(
                                    'No new Id generated. Please refresh the page.',
                                );
                            }
                            this.cdr.detectChanges();
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {
                            this.appService.isShowPageSpinner = false;
                        }),
                    )
                    .subscribe();
            } else {
                const payload = this.prepareSavePayloadBillingTermDetail(
                    this.toEditBillingDetail.ClientBillingTermDetailId,
                );
                this.apiService
                    .httpPutBillingTermDetail(payload)
                    .pipe(
                        tap((res: any) => {
                            this.isShowBillingTermForm = false;

                            this.appService.showCommonMessageDialog(
                                'Success',
                                'Billing Term Detail has been successfully updated.',
                            );

                            this.clients = this.clients?.map(
                                (client: BillingClient) => {
                                    let updatedClient = { ...client };
                                    if (
                                        updatedClient.ClientId ===
                                        this.toEditClientId
                                    ) {
                                        updatedClient.BillingTermDetails =
                                            updatedClient.BillingTermDetails?.map(
                                                (
                                                    termDetail: BillingTermDetail,
                                                ) => {
                                                    let updatedTermDetail = {
                                                        ...termDetail,
                                                    };

                                                    if (
                                                        updatedTermDetail.ClientBillingTermDetailId ===
                                                        this.toEditBillingDetail
                                                            ?.ClientBillingTermDetailId
                                                    ) {
                                                        updatedTermDetail = {
                                                            ...updatedTermDetail,
                                                            ...payload,
                                                            TermType:
                                                                this.termTypeOptions?.find(
                                                                    (
                                                                        i: SelectOption,
                                                                    ) =>
                                                                        i.Value ===
                                                                        payload.TermTypeId,
                                                                )?.Label,
                                                            Creditor:
                                                                this.creditors.find(
                                                                    (i: any) =>
                                                                        i.CreditorId ==
                                                                        payload.CreditorId,
                                                                )?.CompanyName,
                                                        };
                                                    }
                                                    return updatedTermDetail;
                                                },
                                            );
                                    }
                                    return updatedClient;
                                },
                            );
                            this.cdr.detectChanges();
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {
                            this.appService.isShowPageSpinner = false;
                        }),
                    )
                    .subscribe();
            }
        } else {
            this.appService.showCommonMessageDialog(
                'Validation',
                'Please resolve all validation errors first.',
            );
        }
    }

    httpGetAllTermTypes() {
        this.apiService
            .httpGetAllTermType()
            .pipe(
                tap((res: any) => {
                    if (!!res && isArrayWithData(res)) {
                        this.termTypeOptions = res;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    }

    httpGetAllCities() {
        this.apiService
            .httpGetAllCities()
            .pipe(
                tap((res: any) => {
                    if (!!res && isArrayWithData(res)) {
                        this.cityOptions = res;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    }

    httpGetAllStates() {
        this.apiService
            .httpGetAllStates()
            .pipe(
                tap((res: any) => {
                    if (!!res && isArrayWithData(res)) {
                        this.stateOptions = res;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    }

    httpGetAllBillingClients() {
        this.appService.isShowPageSpinner = true;

        this.apiService
            .httpGetAllBillingClients(this.pageClient, this.rowsClient)
            .pipe(
                tap((res: any) => {
                    if (!!res && isArrayWithData(res.Items)) {
                        this.clients = res.Items;
                        this.totalRecordsClient = res.TotalRecords;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                    this.clients = this.clients || [];
                }),
            )
            .subscribe();
    }

    httpGetBillingTermDetailsByClientId(clientId: number) {
        if (!!clientId) {
            this.appService.isShowPageSpinner = true;

            this.apiService
                .httpGetBillingTermDetail(clientId)
                .pipe(
                    tap((res: any) => {
                        if (!!res && isArrayWithData(res.Items)) {
                            const responseBillingTermDetails = res.Items;

                            this.clients = this.clients?.map(
                                (client: BillingClient) => {
                                    let updatedClient = { ...client };

                                    if (updatedClient.ClientId === clientId) {
                                        updatedClient = {
                                            ...updatedClient,
                                            BillingTermDetails:
                                                responseBillingTermDetails,
                                        };
                                    }
                                    return updatedClient;
                                },
                            );
                        }
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                    }),
                )
                .subscribe();
        }
    }

    httpDeleteClient = () => {
        this.apiService
            .httpDeleteBillingClient(this.toDeleteId!)
            .pipe(
                tap(() => {
                    this.appService.showCommonMessageDialog(
                        'Success',
                        'Billing client has been successfully deleted.',
                    );
                    this.clients = this.clients?.filter(
                        (i: any) => i.ClientId !== this.toDeleteId,
                    );
                    this.isDeleteModalVisible = false;
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    httpDeleteBillingTermDetail = () => {
        this.apiService
            .httpDeleteBillingTermDetail(this.toDeleteId!)
            .pipe(
                tap(() => {
                    this.appService.showCommonMessageDialog(
                        'Success',
                        'Client billing term detail has been successfully deleted.',
                    );
                    this.clients = this.clients?.map(
                        (client: BillingClient) => {
                            let updatedClient = { ...client };
                            if (
                                updatedClient.ClientId === this.toEditClientId
                            ) {
                                updatedClient.BillingTermDetails =
                                    client.BillingTermDetails?.filter(
                                        (d: BillingTermDetail) =>
                                            d.ClientBillingTermDetailId !==
                                            this.toDeleteId,
                                    );
                            }
                            return updatedClient;
                        },
                    );
                    this.isDeleteModalVisible = false;
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };
}
